import { api } from "@/api/client";
import { supabase } from "@/lib/supabase";
import type { OrganizationDetail, PatchOrganizationBody } from "@/types/api/organization";

export async function getOrganization(): Promise<OrganizationDetail> {
  const { data } = await api.get<OrganizationDetail>("/v1/organization");
  return data;
}

export async function patchOrganization(body: PatchOrganizationBody): Promise<OrganizationDetail> {
  const { data } = await api.patch<OrganizationDetail>("/v1/organization", body);
  return data;
}

export async function postOrganizationLogo(file: File): Promise<{ logoUrl: string | null }> {
  const mimeType = file.type || "image/jpeg";
  const { data: prepared } = await api.post<{
    imageId: string;
    storagePath: string;
    upload: { bucket: string; path: string; token: string; signedUrl: string };
  }>("/v1/organization/logo/prepare", { mimeType });

  if (!supabase) {
    throw new Error(
      "Supabase is not configured. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.",
    );
  }

  const { error } = await supabase.storage
    .from(prepared.upload.bucket)
    .uploadToSignedUrl(prepared.upload.path, prepared.upload.token, file, {
      contentType: mimeType,
      upsert: true,
    });
  if (error) {
    throw new Error(`Logo upload failed: ${error.message}`);
  }

  const { data } = await api.post<{ logoUrl: string | null }>("/v1/organization/logo/confirm", {
    imageId: prepared.imageId,
    storagePath: prepared.storagePath,
    mimeType,
    sizeBytes: file.size,
  });
  return data;
}

export async function deleteOrganizationLogo(): Promise<{ logoUrl: null }> {
  const { data } = await api.delete<{ logoUrl: null }>("/v1/organization/logo");
  return data;
}
